// import React, { useEffect, useState, useCallback } from "react";
// import AttachedPrescription from "../presecription/AttachedPrescription";
// import { useSelector } from "react-redux";
// import { MdOutlineLocationOn } from "react-icons/md";
// import { apiGET, apiPOST, apiPUT } from "../../utilities/apiHelpers";
// import { toast } from "react-toastify";
// import Popup from "../Address/Popup";
// import { useNavigate } from "react-router-dom";
// import ButtonWithLoader from "../Button/ButtonWithLoader";
// import scrollToTop from "../../utilities/scrollToTop";

// const AddressDetails = ({ stepperProgressCartData }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedAddress, setSelectedAddress] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [addresses, setAddress] = useState([]);
//     const userId = useSelector((state) => state.user?.userData?.id) || "";
//     const navigate = useNavigate();

//     const handleSelect = (address) => {
//         setSelectedAddress(address);
//     };

//     const getUserAddresses = useCallback(async () => {
//         if (!userId) return;
//         try {
//             const response = await apiGET(`/v1/address/getAddress/${userId}`);
//             if (response?.status) {
//                 // Ensure we are setting an array even if data is missing
//                 setAddress(response.data?.data || []);
//             }
//         } catch (error) {
//             console.error("Error fetching addresses", error);
//         }
//     }, [userId]);

//     const setSelectedAddressFunc = async () => {
//         if (!selectedAddress?._id) {
//             toast.error("Please select address to proceed");
//             return;
//         }

//         // SAFETY FIX: Check if selectedPrescription exists and has at least one item
//         const prescriptionId = stepperProgressCartData?.selectedPrescription?.[0]?._id;

//         if (!prescriptionId) {
//             toast.error("Prescription data missing. Please go back and re-upload.");
//             return;
//         }

//         const addOrderPayload = {
//             userId,
//             prescriptionId: prescriptionId, // Uses the safe variable created above
//             mode: 'enquiry',
//             enquiryType: stepperProgressCartData?.prescriptionType || 'asPerPrescription',
//             enquiryStatus: 'awaiting_response',
//             durationUnit: stepperProgressCartData?.prescriptionDurationUnit,
//             durationOfDosage: stepperProgressCartData?.prescriptionDuration,
//             addressId: selectedAddress._id
//         };

//         try {
//             setLoading(true);
//             const addOrderResponse = await apiPOST(`/v1/order/add`, addOrderPayload);

//             if (addOrderResponse?.status) {
//                 toast.success("Order Placed Successfully!");

//                 // Cleanup stepper progress after successful order
//                 try {
//                     const updatePayload = {
//                         selectedAddress: selectedAddress,
//                         currentStepForUploadPres: 0
//                     };
//                     await apiPUT(`/v1/stepper-progress/update-stepper-progress/${userId}`, updatePayload);
//                 } catch (error) {
//                     console.error("Error clearing progress", error);
//                 }

//                 navigate('/enquiries');
//             } else {
//                 toast.error(addOrderResponse?.message || 'Error Adding Order');
//             }
//         } catch (error) {
//             console.error('Error Placing order::', error);
//             toast.error("Something went wrong while placing the order");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (!isOpen) {
//             getUserAddresses();
//         }
//     }, [isOpen, getUserAddresses]);

//     useEffect(() => {
//         scrollToTop();
//     }, []);

//     return (
//         <div className="p-6 mt-4 bg-white shadow-lg rounded-lg mx-auto">
//             <h2 className="text-lg font-semibold mb-2">Address Details</h2>
//             <p className="text-sm text-gray-500 mb-4">Select from saved address</p>

//             <div className="flex lg:flex-row gap-6 flex-col justify-between">
//                 <div className="mb-4 w-full">
//                     <div className="max-h-[380px] overflow-y-auto scrollbar-custom scroll-smooth pr-2">
//                         {addresses && addresses.length > 0 ? (
//                             addresses.map((address) => (
//                                 <div
//                                     key={address._id}
//                                     className={`flex items-center bg-[#F8F8F8] p-4 mb-4 rounded-lg shadow-sm border-2 transition-all cursor-pointer ${selectedAddress?._id === address._id ? 'border-[#14967F] bg-white' : 'border-transparent'
//                                         }`}
//                                     onClick={() => handleSelect(address)}
//                                 >
//                                     <div className={`text-2xl mr-3 ${selectedAddress?._id === address._id ? 'text-[#14967F]' : 'text-gray-400'}`}>
//                                         <MdOutlineLocationOn />
//                                     </div>
//                                     <div>
//                                         <p className="font-bold">{address.zip}</p>
//                                         <p className="text-sm text-gray-600">{address.addressLine1}</p>
//                                         <p className="text-sm text-gray-600">{address.addressLine2}</p>
//                                     </div>
//                                 </div>
//                             ))
//                         ) : (
//                             <div className="p-8 text-center text-gray-400 border-2 border-dashed rounded-lg">
//                                 No addresses saved yet.
//                             </div>
//                         )}
//                     </div>

//                     <div className="flex items-center gap-4 mt-6">
//                         {/* Submit Button Container */}
//                         <div className="h-[44px]">
//                             <ButtonWithLoader
//                                 loading={loading}
//                                 buttonText={"Submit"}
//                                 onClick={setSelectedAddressFunc}
//                                 width={"w-[140px]"} // Slightly wider to accommodate the loader
//                                 className="h-full px-6 rounded-full text-sm font-bold transition-all active:scale-95 flex items-center justify-center"
//                             />
//                         </div>

//                         {/* Add New Address Button */}
//                         <button
//                             onClick={() => setIsOpen(true)}
//                             className="py-[10px] px-6 mt-3 flex items-center justify-center bg-[#F1F9FF] text-[#14967F] text-sm font-bold rounded-full border border-[#14967F]/30 hover:bg-[#e6f4ff] transition-all active:scale-95 whitespace-nowrap"
//                         >
//                             + Add New Address
//                         </button>
//                     </div>
//                 </div>

//                 <div className="lg:w-2/5 lg:border-l-2 lg:pl-6">
//                     <AttachedPrescription
//                         type='uploadPrescription'
//                         stepperProgressCartData={stepperProgressCartData}
//                     />
//                 </div>
//             </div>
//             {isOpen && <Popup isOpen={isOpen} setIsOpen={setIsOpen} />}
//         </div>
//     );
// };

// export default AddressDetails;  


import React, { useEffect, useState, useCallback } from "react";
import AttachedPrescription from "../presecription/AttachedPrescription";
import { useSelector } from "react-redux";
import { MdOutlineLocationOn } from "react-icons/md";
import { apiGET, apiPOST, apiPUT } from "../../utilities/apiHelpers";
import { toast } from "react-toastify";
import Popup from "../Address/Popup";
import { useNavigate } from "react-router-dom";
import ButtonWithLoader from "../Button/ButtonWithLoader";
import scrollToTop from "../../utilities/scrollToTop";

const AddressDetails = ({ stepperProgressCartData }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [loading, setLoading] = useState(false);
    const [addresses, setAddress] = useState([]); // Already initialized as empty array
    const userId = useSelector((state) => state.user?.userData?.id) || "";
    const navigate = useNavigate();

    const handleSelect = (address) => {
        setSelectedAddress(address);
    };

    const getUserAddresses = useCallback(async () => {
        if (!userId) return;
        try {
            const response = await apiGET(`/v1/address/getAddress/${userId}`);
            if (response?.status) {
                // FIX: Ensure we always set an array
                const addressData = response.data?.data;
                const addressArray = Array.isArray(addressData) ? addressData : [];
                setAddress(addressArray);
            } else {
                // If API returns false status, reset to empty array
                setAddress([]);
            }
        } catch (error) {
            console.error("Error fetching addresses", error);
            // Reset to empty array on error
            setAddress([]);
            toast.error("Failed to load addresses");
        }
    }, [userId]);

    const setSelectedAddressFunc = async () => {
        if (!selectedAddress?._id) {
            toast.error("Please select address to proceed");
            return;
        }

        // SAFETY FIX: Check if selectedPrescription exists and has at least one item
        const prescriptionId = stepperProgressCartData?.selectedPrescription?.[0]?._id;

        if (!prescriptionId) {
            toast.error("Prescription data missing. Please go back and re-upload.");
            return;
        }

        const addOrderPayload = {
            userId,
            prescriptionId: prescriptionId, // Uses the safe variable created above
            mode: 'enquiry',
            enquiryType: stepperProgressCartData?.prescriptionType || 'asPerPrescription',
            enquiryStatus: 'awaiting_response',
            durationUnit: stepperProgressCartData?.prescriptionDurationUnit,
            durationOfDosage: stepperProgressCartData?.prescriptionDuration,
            addressId: selectedAddress._id
        };

        try {
            setLoading(true);
            const addOrderResponse = await apiPOST(`/v1/order/add`, addOrderPayload);

            if (addOrderResponse?.status) {
                toast.success("Order Placed Successfully!");

                // Cleanup stepper progress after successful order
                try {
                    const updatePayload = {
                        selectedAddress: selectedAddress,
                        currentStepForUploadPres: 0
                    };
                    await apiPUT(`/v1/stepper-progress/update-stepper-progress/${userId}`, updatePayload);
                } catch (error) {
                    console.error("Error clearing progress", error);
                }

                navigate('/enquiries');
            } else {
                toast.error(addOrderResponse?.message || 'Error Adding Order');
            }
        } catch (error) {
            console.error('Error Placing order::', error);
            toast.error("Something went wrong while placing the order");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!isOpen) {
            getUserAddresses();
        }
    }, [isOpen, getUserAddresses]);

    useEffect(() => {
        scrollToTop();
    }, []);

    return (
        <div className="p-6 mt-4 bg-white shadow-lg rounded-lg mx-auto">
            <h2 className="text-lg font-semibold mb-2">Address Details</h2>
            <p className="text-sm text-gray-500 mb-4">Select from saved address</p>

            <div className="flex lg:flex-row gap-6 flex-col justify-between">
                <div className="mb-4 w-full">
                    <div className="max-h-[380px] overflow-y-auto scrollbar-custom scroll-smooth pr-2">
                        {Array.isArray(addresses) && addresses.length > 0 ? (
                            addresses.map((address) => (
                                <div
                                    key={address._id}
                                    className={`flex items-center bg-[#F8F8F8] p-4 mb-4 rounded-lg shadow-sm border-2 transition-all cursor-pointer ${
                                        selectedAddress?._id === address._id
                                            ? 'border-[#14967F] bg-white'
                                            : 'border-transparent'
                                    }`}
                                    onClick={() => handleSelect(address)}
                                >
                                    <div
                                        className={`text-2xl mr-3 ${
                                            selectedAddress?._id === address._id
                                                ? 'text-[#14967F]'
                                                : 'text-gray-400'
                                        }`}
                                    >
                                        <MdOutlineLocationOn />
                                    </div>
                                    <div>
                                        <p className="font-bold">{address.zip}</p>
                                        <p className="text-sm text-gray-600">{address.addressLine1}</p>
                                        <p className="text-sm text-gray-600">{address.addressLine2}</p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="p-8 text-center text-gray-400 border-2 border-dashed rounded-lg">
                                No addresses saved yet.
                            </div>
                        )}
                    </div>

                    <div className="flex items-center gap-4 mt-6">
                        {/* Submit Button Container */}
                        <div className="h-[44px]">
                            <ButtonWithLoader
                                loading={loading}
                                buttonText={"Submit"}
                                onClick={setSelectedAddressFunc}
                                width={"w-[140px]"}
                                className="h-full px-6 rounded-full text-sm font-bold transition-all active:scale-95 flex items-center justify-center"
                            />
                        </div>

                        {/* Add New Address Button */}
                        <button
                            onClick={() => setIsOpen(true)}
                            className="py-[10px] px-6 mt-3 flex items-center justify-center bg-[#F1F9FF] text-[#14967F] text-sm font-bold rounded-full border border-[#14967F]/30 hover:bg-[#e6f4ff] transition-all active:scale-95 whitespace-nowrap"
                        >
                            + Add New Address
                        </button>
                    </div>
                </div>

                <div className="lg:w-2/5 lg:border-l-2 lg:pl-6">
                    <AttachedPrescription
                        type='uploadPrescription'
                        stepperProgressCartData={stepperProgressCartData}
                    />
                </div>
            </div>
            {isOpen && <Popup isOpen={isOpen} setIsOpen={setIsOpen} />}
        </div>
    );
};

export default AddressDetails;